
import { defineComponent, ref, computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { usePopupStore } from '@/store/popup'
import { useDicomStore } from '@/store/dicom'
import { useReadingResultStore } from '@/store/readingResult'

export default defineComponent({
  components: {
  },
  props:{
  },
  setup(props, {emit}) {
    const popupStore = usePopupStore();
    const dicomStore = useDicomStore();
    const failedFileList = computed(() => dicomStore.getFailedFileList);

    const closePopup = () => {
      popupStore.togglePopup('disk', false);
      dicomStore.initFailedFileList();
    }

    const handleConfirmClick = async (): Promise<void> => {
      closePopup();
    }

    onMounted(() => {
    });

    return {
      closePopup,
      handleConfirmClick,
      failedFileList
    };
  },
});
